<template>
  <li class="emailWrapper" @click="select">
    <div class="icon" v-html="iconImage" />
    <p v-html="email" class="email"></p>
  </li>
</template>

<script>
import Identicon from "identicon.js";

export default {
  props: {
    email: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      iconImage: "",
    };
  },
  mounted() {
    this.iconImage = this.generateIcon();
  },
  methods: {
    select() {
      this.$emit("select", this.email);
    },
    generateIcon() {
      var blake = require("blakejs");
      const emailHash = blake.blake2bHex(this.email);
      var emailImage = new Identicon(emailHash, {
        format: "svg",
        size: 28,
      }).toString();
      return (
        '<img width=28 height=28 src="data:image/svg+xml;base64,' +
        emailImage +
        '">'
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
li.emailWrapper
  +flex(flex-start, center, row)
  padding: 7px 10px
  box-shadow: 0 0 0 1px $gs6
  background-color: $gs1
  border-radius: 5px
  margin-bottom: 10px
  box-sizing: border-box
  cursor: pointer
  transition: 0.3s
  &:last-child
    margin-bottom: 0px
  .icon
    +size(30px, 30px, 50%)
    border: 1px $gs4 solid
    overflow: hidden
    box-sizing: border-box
    margin-right: 6px
  .email
    +fs(m)
    +size(calc(100% - 36px), auto)
    overflow-wrap: break-word
  &:hover
    box-shadow: 0 0 0 2px $color2
    // background-color: rgba(224,224,224,0.5)
</style>
